module.exports = __webpack_public_path__ + "media/Images/woman-working-in-office-77495752c6d2d8fc7bcf18aecc4fad4c.jpg";